import type React from 'react'

export const cmdOrCtrl: string = navigator.platform === 'MacIntel' ? '⌘' : 'Ctrl'
export const cmdOrCtrlPlus: string = navigator.platform === 'MacIntel' ? '⌘' : 'Ctrl+'
export const isEventWithSpecialKeyPressed = (
  e: KeyboardEvent | React.KeyboardEvent | React.MouseEvent,
): boolean => ('button' in e && e.button !== 0) || e.ctrlKey || e.altKey || e.shiftKey || e.metaKey
